import {WithChildren} from '@/_metronic/helpers'
import {FC} from 'react'

const PropagateWrapper: FC<WithChildren> = ({children}) => {
  return <div onClick={(e) => e.stopPropagation()}>{children}</div>
}

export default PropagateWrapper
